{
  "create_schedule_title": "Skapa spelschema",
  "present_schedule_title": "Presentera",
  "create_new": "Skapa nytt",
  "event_code": "Evenemangskod",
  "no_event_found": "Inget evenemang hittades för den angivna koden",
  "created_by_sammandrag_se": "Skapat via sammandrag.se <a href=\"{{baseUrl}}/{{code}}\">{{baseUrl}}/{{code}}</a>",
  "view_count": "Antal visningar: {{count}}",
  "cancel": "Avbryt",
  "ok": "Ok",
  "view": "Visa",
  "show_event_info": "Visa evenemangsinfo",
  "hide_event_info": "Dölj evenemangsinfo",
  "no_previous_schedule": "Jag har inget tidigare spelschema att utgå ifrån och vill skapa ett nytt.",
  "create_login_desc": "Logga in för att redigera dina sparade evenemang",
  "copy": "Kopiera",
  "copy_settings": "Kopiera inställningar och lag från befintligt schemanummer som jag sedan kan ändra",
  "copy_schedule_not_found": "Inget spelschema hittades för det angivna schemanumret.",
  "copy_schedule_failed": "Något gick fel vid kopiering. Försök igen.",
  "schedule_code": "Schemanummer",
  "next": "Nästa",
  "previous": "Föregående",
  "add_text_row_title": "Lägg till textrad",
  "schedule_is_updated": "Ditt spelschema är uppdaterat!",
  "schedule_name_required": "Ange ett namn på spelschemat.",
  "present_schedule": "Presentera schemat",
  "event_saved": "Ditt evenemang är sparat!",
  "unsaved_changes": "Osparade ändringar",
  "group_in_use": "Klassen används i ett schema",
  "venue_in_use": "Planen används i ett schema",
  "done_email_info": "Dela direktlänken eller evenemangsnumret med deltagarna.",
  "event_code_with_code": "Evenemangsnummer: {{eventCode}}",
  "direct_link": "Direktlänk:",
  "registration_link": "Anmälningslänk:",
  "event_visibility": "Synlighet",
  "event_visibility_public": "Publikt",
  "event_visibility_private": "Privat",
  "event_visibility_help": "Publika evenemang visas på kartan (om plats är angiven) och kan sökas fram där. Privata evenemang visas inte och går inte att söka fram.",
  "sport": "Sport",
  "sport_not_set": "Ej valt",
  "sport_soccer": "Fotboll",
  "sport_basketball": "Basket",
  "sport_field_hockey": "Landhockey",
  "sport_ice_hockey": "Ishockey",
  "sport_floorball": "Innebandy",
  "sport_handball": "Handboll",
  "sport_volleyball": "Volleyboll",
  "sport_rugby": "Rugby",
  "sport_cricket": "Cricket",
  "sport_baseball": "Baseboll",
  "sport_softball": "Softboll",
  "sport_american_football": "Amerikansk fotboll",
  "sport_badminton": "Badminton",
  "sport_tennis": "Tennis",
  "sport_table_tennis": "Bordtennis",
  "sport_beach_volleyball": "Beachvolleyboll",
  "sport_other": "Annat",
  "sport_other_placeholder": "Ange sport",
  "sport_filter_all": "Alla sporter",
  "email": "E-post",
  "back": "Tillbaka",
  "preview": "Förhandsgranska",
  "enter_email": "Ange din e-post",
  "why_email_info": "Evenemanget kopplas till din e-post så du kan redigera det senare. Du kommer få två mejl. Ett för dig som administratör av evenemanget och ett du kan vidarebefordra till deltagare i ditt evenemang.",
  "event_info": "Evenemangsinfo",
  "no_event_info": "Klicka på Redigera för att fylla i evenemangsinfo",
  "email_required": "En epostadress måste anges",
  "schedule_overwrite_warning": "Ditt tidigare sparade spelschema kommer skrivas över med de ändringar du gjort. Det nya spelschemat kommer behålla samma schemanummer. Denna åtgärd går inte att ångra.",
  "message_sent": "Ditt meddelande har skickats!",
  "field_count": "Antal Planer",
  "period_count": "Antal Perioder",
  "period_length": "Periodlängd",
  "period_pause": "Periodpaus",
  "game_pause": "Paus mellan matcher",
  "field_count_adjust_info": "Ditt val av antal planer kräver minst {{minTeamCount}} deltagande lag. Vid färre lag justeras antaler planer automatiskt.",
  "game_format": "Spelupplägg",
  "start_time": "Starttid",
  "no_teams_added": "Inga lag tillagda",
  "team_association_count": "Antal lag: {{teamCount}}, Antal föreningar {{associationCount}}",
  "association_team": "Förening/Lag",
  "suffix": "Suffix",
  "team_suffix_placeholder": "Ex. 1, 2, Röd, F18",
  "game_count": "Antal matcher",
  "game_count_default": "Enl. spelupplägg",
  "max_team_count_info": "Max 120 lag tillåts för närvarande. Har du fler lag prova dela upp lagen i två separata spelscheman.",
  "min_association_count_info": "Minst två föreningar behövs för att skapa ett spelschema",
  "add": "Lägg till",
  "update": "Uppdatera",
  "games_per_team": "Antal matcher per lag",
  "team_count": "Antal lag",
  "association": "Förening",
  "attending_teams": "Deltagande lag",
  "remove": "Ta bort",
  "delete_association": "Ta bort föreningen",
  "delete_single_team": "Ta bort enskilt lag",
  "duplicate_suffix_error": "Lagnamnen inom föreningen är inte unik – ändra namnet på laget för att undvika namnkonflikter.",
  "generate_schedule": "Generera spelschema",
  "generating_schedule_spinner": "Skapar spelschema, det kan ta en liten stund...",
  "no_schedule_found": "Inget spelschema kunde skapas med de angivna inställningarna.",
  "game_schedule": "Spelschema",
  "move_schedule_up": "Flytta upp",
  "move_schedule_down": "Flytta ner",
  "your_association": "Din förenings namn",
  "date": "Datum",
  "location": "Plats",
  "other": "Övrigt",
  "association_placeholder": "Föreningen IK",
  "location_placeholder": "Adress eller vägbeskrivning",
  "other_placeholder": "Övrig information. Ex. Är kiosken öppen?",
  "when": "{{date, localDateFormat}}",
  "when_range": "{{start, localDateFormat}} - {{end, localDateFormat}}",
  "shedule_present_title": "Välkommen till {{association}}",
  "text": "Text",
  "position": "Position",
  "duration": "Varaktighet",
  "time": "Tid",
  "interval": "Omgång",
  "games": "Matcher",
  "custom_row_text_placeholder": "T.ex. Lunchpaus",
  "penalty_no_remarks": "Spelschemat har inga anmärkningar",
  "penalty_is_not_valid": "Spelschemat innehåller ogiltiga matcher",
  "penalty_has_removed_teams": "Spelschemat innehåller matcher med borttagna lag",
  "mutual_meeting_title": "Inbördes möten",
  "mutual_meeting_content": "Det går inte att undvika inbördes möten mellan samma förening med aktuell laguppställning.",
  "penalty_same_associations": "{{sameAssociationAsOpponentCount}} möten mellan samma förening!",
  "penalty_same_opponents": "{{sameOpponentCount}} lag möter samma motståndare fler än en gång!",
  "penalty_same_opponent_association": "{{sameOpponentAssociationCount}} lag möter samma förening fler än en gång",
  "penalty_own_association": "{{ownAssociationCount}} inbördes möten inom samma förening!",
  "penalty_adjacent_intervals": "{{adjacentIntervalCount}} förekomster av lag med matcher i direkt anslutning till varandra",
  "penalty_extra_intervals": "Spelschemat har {{extraIntervals}} extra omgång(ar)",
  "penalty_reminder": "{{reminderTeam}} spelar en extra match p.g.a antal deltagande lag",
  "adjacent_games": "Intilligande matcher",
  "adjacent_games_info": "För vissa spelupplägg och laguppsättningar går det inte att undvika matcher i direkt anslutning utan att skapa extra omgångar. Att tillåta både matcher i direkt anslutning och extra omgångar kan ge en bra kompromiss",
  "extra_intervals": "Extra omgångar",
  "extra_intervals_info": "Extra omgångar kan behövas vid spelupplägg med många planer eller få deltagande föreningar. Att tillåta intilliggande matcher kan minska antalet extra omgångar.",
  "extra_game": "Extra match",
  "extra_game_info": "Aktuell laguppsättning kräver att något lag spelar en extra match. Du kan styra vilket lag genom att i föregående steg öka antalet matcher med ett för det önskade laget.",
  "opponent": "Motståndare",
  "field_name": "Plan {{fieldNumber}}",
  "add_team": "Lägg till lag",
  "duplicate_association_name": "Namnet används redan",
  "duplicate_team_name": "Lagnamnen krockar",
  "duplicate_team_name_error": "Ett lagnamn är identiskt med ett annat lags namn (föreningsnamn plus lagnamn). Ändra förenings- eller lagnamnet.",
  "remove_row": "Ta bort rad",
  "add_row": "Lägg till rad",
  "drag_here_to_remove_from_schedule": "Dra och släpp här för att ta bort lag ur spelschemat",
  "edit_play_order": "Redigera spelordning",
  "mobile_schedule_select_hint": "Tryck på ett lag i schemat, eller ett borttaget lag nedanför, för att välja det",
  "mobile_schedule_swap_hint": "Tryck på en annan plats för att byta, eller tryck på samma plats igen för att avmarkera",
  "mobile_removed_team_selected_hint": "Tryck på en plats i schemat för att placera laget där",
  "mobile_no_removed_teams": "Inga lag väntar utanför schemat",
  "mobile_removed_teams_hint": "Tryck på ett borttaget lag för att lägga tillbaka det på en vald ledig plats",
  "mobile_remove_team_or_swap_hint": "Tryck på \"Ta bort ur schema\" för att ta bort valt lag, eller tryck på ett borttaget lag för att byta plats",
  "mobile_remove_from_schedule": "Ta bort ur schema",
  "schedule_game_format": "Spelupplägg: {{periods}} x {{periodLength}} minuter",
  "schedule_schedule_code": ", schemanummer {{scheduleCode}}",
  "team": "Lag",
  "free": "Ledig",
  "allow_adjacent_games": "Lag tillåts ha matcher i direkt anslutning till varandra",
  "allow_adjacent_games_help_title": "Intilligande matcher",
  "allow_adjacent_games_help_content": "Tillåt lag ha matcher i direkt anslutning till varandra. Sådana matcher undviks om möjligt även med denna inställning ikryssad. För vissa spelupplägg och laguppsättningar går det inte att undvika utan att skapa extra omgångar.",
  "max_extra_rounds": "Extra omgångar",
  "max_extra_rounds_auto": "Auto (rekommenderas)",
  "max_extra_rounds_none": "Inga",
  "max_extra_rounds_option": "Max {{count}}",
  "allow_extra_intervals_help_content": "Extra omgångar är omgångar där spelschemat har luckor. De kan behövas i fall där många planer önskas, vid få deltagande föreningar eller för att minska antalet matcher i direkt anslutning till varandra. Auto väljer en lämplig gräns för ditt upplägg, eller välj max antal extra omgångar som tillåts.",
  "manual_edit_info_title": "Visste du att du kan nu även kan redigera ditt spelschema manuellt. Läs mer här",
  "edit_schedule_help_title": "Hantera spelscheman",
  "edit_schedule_help_content": "Du kan redigera spelordningen både på dator och mobil. Tryck på redigeringsikonen överst i spelschemat, klicka på ett lag för att markera det och klicka sedan på den plats du vill flytta det till. Lägg till ytterligare omgångar genom att trycka på + knappen på sista raden. Lägg till ytterligare matcher för ett lag genom att trycka på \"Lägg till lag\", klicka på laget och sedan på önskad plats i spelschemat.",
  "terms_and_conditions": "<h4>Villkor och ansvar</h4> <p>Tjänsten tillhandahålls utan kostnad. Används annan presentation än via sammandrag.se (t.ex. genom egna utskrifter eller egna utskick) skall det tydligt framgå att spelschemat är skapat via sammandrag.se. Sammandrag.se kan inte garantera oavbruten tillgång till tjänsten då webbplatsen kan komma att störas av faktorer utanför vår kontroll och vi ställer inga garantier gällande webbplatsens funktion eller tillgänglighet. Sammandrag.se kan inte göras ansvarigt för skador som direkt eller indirekt orsakas av användning av webbplatsen och dess innehåll.</p><h3>Integritetspolicy</h3><p>Vi tar din integritet på stort allvar. Din e-post adress sparas tillsammans med spelschemat du skapat för att ge möjligheten att redigera spelschemat. Vi kommer inte använda uppgifterna i annat syfte än vad som är nödvändigt för tjänstens funktion.</p>",
  "accept_conditions": "Genom att slutföra godkänner jag användarvillkoren som finns att läsa ",
  "accept_conditions_link_text": "här",
  "finish": "Slutför",
  "schedule_code_placeholder": "ABC123",
  "association_name_placeholder": "Föreningsnamn",
  "generate_schedule_title": "Du kan generera flera scheman för att jämföra och sedan välja det du tycker passar bäst",
  "before_interval_one": "Före omgång 1",
  "after_interval": "Efter omgång",
  "location_with_params": "{{location}}",
  "organizer_with_params": "{{organizer}}",
  "get": "Hämta",
  "save_schedule_exists_info": "Ett nytt schema har skapats p.g.a. av gjorda ändringar. Ditt tidigare sparade schema hittar du längre ned på sidan och du hellre önskar redigera det manuellt",
  "nav_create": "Skapa",
  "nav_edit": "Redigera",
  "nav_present": "Presentera",
  "nav_about": "Om",
  "about_the_service_header": "Om tjänsten",
  "contact_us_title": "Kontakta oss",
  "contact_us_content": "Har du idéer, önskemål, problem eller av annan anledning vill komma i kontakt så använd formuläret nedan",
  "message_title": "Meddelande",
  "message_placeholder": "Ditt meddelande",
  "send": "Skicka",
  "field": "Plan",
  "start_date": "Startdatum",
  "end_date": "Slutdatum",
  "description": "Beskrivning",
  "review_schedule_header": "Granska spelschemat",
  "create_single_schedule_title": "Skapa nytt evenemang med endast ett spelschema",
  "create_multiple_schedules_title": "Skapa nytt evenemang med flera spelscheman",
  "schedule_name": "Namn",
  "schedule_name_placeholder": "Schemanamn",
  "schedule_description": "Beskrivning",
  "schedule_description_placeholder": "Gruppspel",
  "schedule_description_help_title": "Beskrivning av spelschema",
  "schedule_description_help_content": "Har du flera spelscheman för samma klass behöver du ange en beskrivning för att kunna skilja dem åt. T.ex. Gruppspel, final",
  "day": "Dag",
  "title": "Titel",
  "event_title_placeholder": "Välkommen på sammandrag för Div 5 flickor",
  "event_description_placeholder": "Kiosken är öppen, Välkomna!",
  "organizer": "Organisatör",
  "event_summary_title": "Översikt",
  "add_schedule": "Lägg till spelschema",
  "game_schedules": "Spelscheman",
  "no_schedules_added": "Inga spelscheman tillagda",
  "all": "Alla",
  "name": "Namn",
  "group": "Klass",
  "group_name_placeholder": "t.ex F2018/P15",
  "visibility": "Synlighet",
  "manage_groups": "Hantera klasser",
  "manage_venues": "Hantera planer",
  "add_venue": "Lägg till plan",
  "venue_name": "Namn",
  "venue_name_placeholder": "t.ex. Konstgräs",
  "no_venues_added": "Inga planer tillagda",
  "delete_venue": "Ta bort plan",
  "save": "Spara",
  "nav_login": "Logga in",
  "nav_logout": "Logga ut",
  "nav_my_events": "Mina evenemang",
  "nav_invites": "Inbjudningar",
  "shared_event": "Delad",
  "share_accept": "Acceptera",
  "share_decline": "Neka",
  "share_leave": "Lämna",
  "participant_event": "Deltagare",
  "participant_registration": "Gå till registrering",
  "participant_leave": "Lämna föreningen",
  "pending_invites_message": "Du har {{count}} väntande inbjudningar.",
  "pending_invites_link": "Visa",
  "invites_back_to_my_events": "Tillbaka till mina evenemang",
  "invites_none_found": "Du har inga väntande inbjudningar.",
  "registration_revoke": "Återkalla registrering",
  "registration_revoke_confirmation": "Återkalla registreringen. Alla lag och medlemmar i föreningen tas bort. Är du säker? Detta kan inte ångras",
  "edit_event_registration_enable": "Aktivera publik registrering",
  "edit_event_registration_help_title": "Publik registrering",
  "edit_event_registration_help_content": "Publik registrering aktiverar ett anmälningsformulär där deltagarna själva kan anmäla sina lag och ange kontaktuppgifter. Information går sedan att justera innan du skapar ditt spelschema",
  "edit_event_registration_closes": "Registrering stänger",
  "registration_heading": "Registrering",
  "registration_event_not_found": "Det finns inget evenemang med den koden.",
  "registration_organizer_label": "Arrangör:",
  "registration_date_label": "Datum:",
  "registration_location_label": "Plats:",
  "registration_location_not_specified": "Ej angiven",
  "registration_no_description": "Ingen beskrivning",
  "registration_closed_message": "Registreringen har stängts och går inte längre att ändra. Kontakta arrangören om du behöver hjälp.",
  "registration_not_open_message": "Registrering är inte öppen för detta evenemang.",
  "registration_invited_as": "Du har bjudits in som {{role}} i det här laget.",
  "registration_accept_invite": "Acceptera inbjudan",
  "registration_add_team": "Lägg till lag",
  "registration_no_teams_registered": "Inga lag registrerade.",
  "registration_members_heading": "Kontaktpersoner",
  "edit_teams_contacts_help_content": "Lägg till kontaktpersoner för att enkelt kunna ta kontakt senare. Ingen e-post eller annat meddelande skickas men om användaren är inloggad kommer evenemanget visas med rättigheten deltagare",
  "add_contact_person": "Lägg till kontaktperson",
  "no_contacts_added": "Inga kontaktpersoner tillagda",
  "registration_member_pending": "Väntar",
  "registration_invite_button": "Lägg till",
  "contact_email_placeholder": "coach@example.com",
  "role_manager": "Administratör",
  "role_contact": "Kontakt",
  "registration_closed_contact_organizer": "Registreringen är stängd. Alla förändringar måste göras genom arrangören.",
  "registration_available_groups_heading": "Tillgängliga grupper",
  "registration_new_title": "Registrera lag",
  "registration_login_prompt": "Logga in för att kunna skapa ett lag och skicka in registreringen.",
  "registration_new_title_with_group": "Registrera lag – {{group}}",
  "registration_save": "Spara registrering",
  "registration_group_fallback": "Grupp",
  "registration_validation_message": "Ange grupp, föreningsnamn och minst ett lag.",
  "registration_save_failed": "Registreringen kunde inte sparas.",
  "registration_save_success": "Din registrering har skickats.",
  "registration_cannot_leave_last_manager": "Du är den enda accepterade ledaren och kan inte lämna förening/laget.",
  "login_title": "Logga in",
  "login_with_microsoft": "Fortsätt med Microsoft",
  "login_with_google": "Fortsätt med Google",
  "login_with_apple": "Fortsätt med Apple",
  "no_events_found": "Du har inga sparade evenemang.",
  "orphan_event": "Ta bort från mina evenemang",
  "orphan_event_confirmation": "Ta bort evenemanget. Är du säker? Detta kan inte ångras",
  "my_events_toggle_advanced_tools": "Importera evenemang",
  "edit": "Redigera",
  "share": "Dela",
  "share_whatsapp": "Dela på WhatsApp",
  "share_facebook": "Dela på Facebook",
  "copy_link": "Kopiera länk",
  "teams": "Lag",
  "manage_teams": "Hantera lag",
  "no_groups_added": "Inga klasser tillagda",
  "team_count_label": "Antal lag",
  "team_count_for_association": "Antal lag i denna förening",
  "team_count_for_association_help": "Gäller endast föreningen du just nu lägger till. Totalt antal lag i klassen visas nedan.",
  "add_team_association_label": "Föreningsnamn",
  "add_team_count_label": "Antal lag från denna förening",
  "add_team_count_help": "Hur många lag deltar från denna förening i klassen.",
  "team_count_total_in_group": "Totalt antal lag i klassen: {{count}}",
  "team_count_total_after_add": "Efter Lägg till: {{count}}",
  "team_totals_for_group": "Totalt antal i {{groupName}}: Föreningar {{associationCount}}, Lag {{teamCount}}",
  "association_team_count": "{{count}} lag",
  "expand": "Visa mer",
  "collapse": "Visa mindre",
  "select_group": "Välj klass",
  "serie_group_section_title": "Klassval för spelschemat",
  "serie_group_help": "Välj klasser. Ett kombinerat schema hjälper dig att optimera planfördelning och förenkla schemaläggning för flera klasser samtidigt.",
  "serie_group_selected_count": "Valda klasser: {{count}}",
  "new_group": "Ny klass",
  "group_filter": "Filtrera på klass",
  "all_groups": "Alla klasser",
  "team_distribution_strategy": "Lagfördelning",
  "team_distribution_strategy_optimized": "Optimerad (rekommenderas)",
  "team_distribution_strategy_distributed": "Fördelad",
  "team_distribution_strategy_help_title": "Lagfördelning",
  "team_distribution_strategy_help_content": "Optimerad minimerar total tid per klass och fyller återstående platser med andra klasser. Fördelad sprider alla lag jämnt över hela schemat, vilket kan göra att varje klass pågår längre.",
  "nav_map": "Karta",
  "geocode_search": "Sök",
  "geocode_clear": "Rensa koordinater",
  "geocode_not_found": "Adressen hittades inte. Prova en annan stavning.",
  "geocode_hint": "Klicka på kartan för att placera nålen eller dra den till önskad plats.",
  "open_maps": "Öppna i karttjänst",
  "map_from_date": "Från datum",
  "map_to_date": "Till datum",
  "map_search_label": "Förening/adress",
  "map_search_placeholder": "Sök förening eller adress",
  "map_search": "Sök",
  "map_event_count": "{{count}} evenemang visas",
  "map_load_error": "Kunde inte hämta evenemang. Försök igen.",
  "event_comments_header": "Meddelanden",
  "event_comment_placeholder": "Skriv ett meddelande",
  "event_comments_help_content": "Skapa korta meddelanden som visas omedelbart på evenemangsidan. Dessa går sedan även att redigera eller ta bort",
  "event_comment_add": "Lägg till",
  "event_no_comments": "Inga meddelanden tillagda",
  "event_comments_show_more": "Visa fler...",
  "event_comments_show_less": "Visa färre",
  "passkey_register": "Registrera med passkey",
  "passkey_sign_in": "Logga in med passkey",
  "passkey_not_supported": "Din webbläsare stöder inte passkeys",
  "passkey_registering": "Registrerar...",
  "passkey_signing_in": "Loggar in...",
  "passkey_not_registered": "Ingen passkey är registrerad för den här e-postadressen. Klicka på \"Registrera med passkey\" för att skapa en.",
  "login_continue": "Fortsätt",
  "login_checking": "Kontrollerar...",
  "login_methods_for": "Inloggningssätt för",
  "login_back": "← Tillbaka",
  "login_provider_mismatch": "Det finns redan ett konto med den här e-postadressen registrerat via en annan inloggningsmetod. Använd den metod du använde när du skapade kontot.",
  "login_email_label": "Logga in med e-post",
  "email_code_send": "Skicka e-postkod",
  "email_code_sending": "Skickar kod...",
  "email_code_sent": "Ange koden",
  "email_code_check_email": "Vi skickade en 6-siffrig kod till {{email}}. Ange den nedan för att logga in.",
  "email_code_label": "6-siffrig kod",
  "email_code_verify": "Verifiera kod",
  "email_code_verifying": "Verifierar...",
  "email_code_invalid": "Koden är felaktig eller har gått ut. Kontrollera koden och försök igen, eller skicka en ny kod.",
  "login_too_many_requests": "Du har gjort för många försök. Vänta en stund och försök igen.",
  "too_many_requests": "För många förfrågningar. Vänta en stund och försök igen.",
  "login_or": "Eller",
  "login_social_header": "Logga in med socialt konto",
  "login_passkey_header": "Logga in med passkey",
  "login_magic_header": "Logga in med e-postlänk",
  "share_event": "Dela",
  "share_event_title": "Dela evenemang",
  "share_add": "Lägg till",
  "share_email": "E-postadress",
  "share_permission_can_edit": "Kan redigera",
  "share_revoke": "Ta bort",
  "share_pending": "Väntar på acceptans",
  "share_add_success": "Åtkomst beviljad",
  "share_add_error": "Kunde inte bevilja åtkomst",
  "share_can_edit_info": "Personer du delar med kan redigera evenemanget.",
  "share_send_info_title": "Skicka information via e-post",
  "share_send_invitation": "Skicka",
  "share_send_invitation_hint": "Skapa en inbjudan som kan vidarebefordras till deltagande lag. Skickas till din e-post.",
  "share_send_registration": "Skicka",
  "share_send_registration_hint": "Skapa anmälningsinformation som kan vidarebefordras till lag för anmälan. Skickas till din e-post.",
  "share_invitation_sent": "Inbjudningsinformation har skickats till din e-post.",
  "share_invitation_error": "Kunde inte skicka inbjudningsinformation.",
  "share_registration_sent": "Anmälningsinformation har skickats till din e-post.",
  "share_registration_error": "Kunde inte skicka anmälningsinformation.",
  "import_event_title": "Importera evenemang",
  "import_event_desc": "Ange evenemangskod och PIN från dina äldre evenemang för att importera dessa till dina evenemang.",
  "import_event_code_label": "Evenemangskod",
  "import_event_pin_label": "PIN (från gammal redigeringslänk)",
  "import_event_pin_short": "PIN",
  "import_event_button": "Ta över evenemang",
  "import_event_owned_by_other": "Det här evenemanget ägs redan av en annan användare.",
  "import_event_invalid_pin": "Fel PIN. Kontrollera din gamla redigeringslänk.",
  "import_event_not_found": "Inget evenemang hittades med den koden.",
  "import_event_success": "Evenemang övertaget!",
  "save_requires_login": "Du måste vara inloggad för att spara evenemanget.",
  "click_here_to_login": "Klicka här för att logga in",
  "account_title": "Mitt konto",
  "account_section_profile": "Profil",
  "account_email_label": "E-postadress",
  "account_section_consents": "Samtycken",
  "account_email_consent_label": "Jag vill ta emot nyheter och information från sammandrag.se",
  "account_email_consent_info": "Du kan ändra detta samtycke när som helst.",
  "account_cookie_settings_button": "Hantera cookie-inställningar",
  "account_section_language": "Språk",
  "account_language_info": "Välj språk för appen.",
  "account_logout_button": "Logga ut",
  "account_section_danger": "Farlig zon",
  "account_delete_info": "Att radera ditt konto tar bort alla dina personuppgifter. Åtgärden kan inte ångras.",
  "account_delete_button": "Radera mitt konto",
  "account_delete_confirm_prompt": "Är du säker? Detta går inte att ångra.",
  "account_delete_confirm_button": "Ja, radera",
  "account_section_passkeys": "Passkeys",
  "account_section_providers": "Inloggningsmetoder",
  "account_provider_linked": "Ansluten",
  "account_provider_link": "Lägg till",
  "account_passkey_info": "Registrera en passkey på din enhet för lösenordsfri inloggning.",
  "account_passkey_register_button": "Registrera passkey",
  "account_passkey_registered": "Passkey registrerad! Du kan nu logga in med den här enheten.",
  "account_passkey_registered_badge": "Antal registrerade passkeys: {{count}}",
  "onboarding_title": "Välkommen till sammandrag.se",
  "onboarding_intro": "Läs igenom och acceptera villkoren för att fortsätta.",
  "onboarding_accept_terms_prefix": "Jag har läst och accepterar",
  "onboarding_terms_link": "användarvillkoren",
  "onboarding_and": "och",
  "onboarding_privacy_link": "integritetspolicyn",
  "onboarding_email_consent_optional": "Frivilligt. Du kan ändra detta när som helst under Mitt konto.",
  "onboarding_continue": "Fortsätt"
}
